import { InjectionToken } from '@angular/core';

import type { SchedulerLinkDropdownInterface } from '@core/wysiwyg-legacy';

export const SchedulerLinksDropdownToken = new InjectionToken<
  new (...args: any[]) => SchedulerLinkDropdownInterface
>('SchedulerLinksDropdownToken');
